import { AfterViewInit, Directive, ElementRef, HostListener, OnDestroy, Optional } from '@angular/core';
import { NgModel } from '@angular/forms';
import { Subscription } from 'rxjs';

@Directive({
  selector: 'textarea[autoResize]'
})
export class TextareaAutoresize implements AfterViewInit, OnDestroy {
  private sub?: Subscription;

  constructor(private el: ElementRef, @Optional() private ngModel?: NgModel) { }

  ngAfterViewInit() {
    if (this.ngModel?.control?.valueChanges) {
      this.sub = this.ngModel.control.valueChanges.subscribe(() => {
        this.resize();
      });
    }
    this.resize();
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }

  @HostListener('input')
  onInput() {
    this.resize();
  }

  private resize() {
    requestAnimationFrame(() => {
      const textarea = this.el.nativeElement as HTMLTextAreaElement;
      textarea.style.height = 'auto';
      textarea.style.height = (textarea.scrollHeight + 2) + 'px';
    });
  }
}